module.exports = {
    common: {
        "alert": "Alert",
        "submit": "Bekræft indsndelse",
        "sure": "Sure",
        "save": "Save",
        "ok": "Ok",
        "cancel": "Annuller",
        "close": "Luk",
        "back": "Tilbage",
        "result": "Resultat",
        "connotAccessed": "Nettet kan ikke tilgås, kontakt venligst administratoren!",
        "invalid": "Siden er ugyldig. Scan QR-koden igen!",
        "selectPackage": "Vælg venligst mindst ét pakkenummer korrekt",
        "increased": "Antallet af personer kan kun øges!",
        "moreNeed": "Denne tabel er blevet placeret i {beginNum}kopier, og {nowNum} er tilføjet i øjeblikket. Er du sikker på, at du skal tilføje dem",
        "orderSuccess": "Din ordre er blevet afsendt.",
        "orderstatechange": "Ordrestatus er ændret, bestil venligst.",
        "orderSuccessfully": "Bestil vellykket!",
        "orderFailed": "Ordre mislykkedes!",
        "operationFailed": "Handlingen mislykkedes!",
        "addSuccessfully": "tilføj med succes!",
        "pageInvalid": "Siden er ugyldig. Scan QR-koden igen!",
        "deleteConfirm": "Er du sikker på at slette dette emne?",
        "confirm":"Bekræft",
        "order":"Ordre",
        "submitOrder":"Sendt ordre",
    },
    login: {
        "name": "Navn",
        "telephone": "Din telefon number",
        "begin": "Start",
        "number": "Nummer",
        "beginTime": "Start tid",
        "anonymous": "Indtast anonymt",
        "nameNotNull": "Navn skal udfyldes.",
        "phoneNotNull": "Telefonummer skal udfyldes.",
        "accepetSendMsg":"Tillad at modtage sms.",
    },
    buffetselect: {
        'title': "All you can eat",
        "info":"Hvis du er yngre end 12 år, skal du bestille et sæt børnemåltid. Hvis du er ældre end 12 år, skal du bestille et voksenmåltid. Hvor mange personer skal udfylde felterne for buffetmåltid under",
        "next": "Næste",
        "successTip": " Du har bestilt buffetpakken. Begynd venligst at bestille buffeten. Tak!",
        "startBuffet": "Start buffet",
        "more": "Mere",
        "refresh": "Opdatet",
        "moreNumber": "flere nummer",
        "successfulOrderTip":"Vellykket ordre",
        "dear": "Kære",
        "dinnerAsk":"Hvor mange mennesker til middag?",
        "selectDinnerNum":"Vælg venligst antallet af spisende gæster",
        "moreNumBtn":"Flere nummer, påkrævet",
        "tasteRequired":"Dit smagskrav, ikke påkrævet",
        "startOrder": "Begynd at bestile",
    },
    header: {
        "info":"Info",
        "cartList": "Indvognsliste",
        "cartListDsc": "Din indkøbskurv",
        "billList": "Rekningsliste",
        "billListDsc": "Bestilte ordrer",
        "modify": "Nyt tilføjet",
        "modifyDsc": "Nyt antal personer",
        "artServices": "Kald service",
        "artServicesDsc": "Kald servicepersonalet",
        "confirmTips": "Bekræft",
        "continueText": "Hvis der er retter i indkøbskurven, der skal bekræftes, før du afgiver en ordre, bedes du venligst bekræfte, om du vil fortsætte med at returnere?",
        "humanText": "Har du brug for at ringe til servicepersonalet?",
        "selectLanguage": "Vælg sprog",
        "calledService": "Du har ringet til den manuelle service, vent venligst tålmodigt!",
        "calledSuccessfully":"Du har ringet, vent venligst på servicepersonalet!"
    },
    buffet: {
        "tip": "OBS! Hvis der er mere end 4 stk. sushi / forretter tilovers på bordet når i er færdige med at spise, betales kr. 15 pr. stk. Som tillægges ALL-You-Can-Eat prisen.",
        "freePark": "Gratis park",
        "payPark": "Betal park",
        "recommend": "Anbefal",
        "checklist": "Tjekliste",
        "reminder": "Påmindelse",
        "next": "Næste",
        "total": "Total",
        "share": "Del",
        "startOrder": "Start ordre",
        "nullOrder": "Du har ikke afgivet din ordre, vælg venligst de retter, du vil bestille!",
        "summary": "Oversigt",
        "cartList": "Indvognsliste",
        "history": "Historie",
        "served": "Afslut",
        "nserved": "ikke afslut",
    },
    orderList: {
        "all": "Alle",
        "total": "Total",
        "refresh": "Opdater",
        "home": "Tilføj flere retter",
        "return": "Tilbage til vælg menuer",
        "info": "Information",
        "frist": "Førstegangs ordren",
        "second": "Anden gangs ordren",
        "third": "Tredje ordren",
        "fourth": "Fjerde gang ordren",
        "moreth": 'Den {times}th order',
        "morePeople": "Flere",
        "orderSubmitted": "Ordre afsendes, vent venligst stk tid!",
        "submitCart": "Du har ikke valgt retter, eller din partner har bekræftet at indsende indkøbskurvlisten!",
        "sendKitchen": "Send til køkken",
        "remark": "Bemærkning",
        "choice": "valg",
        "with": "valg",
        "chooseWith": "Vælg din med",
        "selectOne": "Vælg en",
        "oneOnlyOrder": "En person kan kun bestille",
        "onePersonOrder": "Én person kan kun bestille {num}",
        "maxEachTimeOrder":"Hver gang kan maksimalt {num} portioner bestilles.",
        "timeLimit": "Du kan kun bestille {num} ad gangen",
        "agreeWait": "Du skal acceptere ventetiden, før du afgiver en ordre",
        "noDishes": "Indvognslisten har ingen retter, kan ikke indsendes, eller bekræft venligst, at den er blevet indsendt!",
        "submittedTips": "Din ordre er blevet indsendt eller indsendt af andre partnere. Indsend venligst ikke igen",
        "orderClosedTips": "Ordren er blevet lukket, skan venligst QR-koden her for at bestille, tak!",
        "reminderTips": "Køkkenet har modtaget din påmindelse. Vent venligst 5 minutter, før du sender den!",
        "reminderSuccessfully": "Påmindelsen lykkedes",
        "selectNumber": "Du har ikke valgt antallet af personer, vælg venligst antallet af personer og begynd at bestille!",
        "orderChangeTip":"Ordreændringstip",
        "deliveryType":"Levering",
        "pickUp":"Afhent",
        "delivered":"Levering",
        "deliveryTypeNotNull":"Vælg venligst leveringsmetoden.",
        "dateNotNull":"Vælg venligst ordredatoen.",
        "timeNotNull":"Vælg venligst bestillingstidspunktet.",
        "orderDate":"Ordredato",
        "orderTime":"Bestil tid",
        "name":"Navn",
        "telephone":"Telefon",
        "email":"Email",
        "postNummer":"Post nummer",
        "postBy":"By",
        "address":"Adresse",
        "number":"Nummer",
        "adult":"Voksen",
        "children":"Børn",
        "specielle":"bemærkninger",
        "telephoneNotNull":"Indtast venligst telefonnummeret",
        "nameNotNull":"Indtast venligst dit navn",
        "emailNotNull":"Indtast venligst en e-mail",
        "numberNotNull":"Indtast venligst antallet af personer",
        "postNummerNotNull":"Indtast venligst postnummeret",
        "postByNotNull":"Indtast venligst postens navn",
        "addressNotNull":"Indtast venligst postadressen",
        "customerInfo":"Ordreinformation",
        "methodAndTime":"Levering tid",
        "orderNo":"Afhentningskode",
        "deliveryFee":"Gebyr for levering",
        "orderNotNull":"Du har ikke bestilt nogen retter. Gå venligst tilbage og vælg de tilsvarende retter",
        "orderList":"Min ordreliste",
        "subAmount":"Subtotal",
        "postAmount":"Gebyr for levering",
        "emailError":"Indtast venligst det korrekte e-mail-format",
        "confirmOrder":"Bekræft ordre",
        "limitTimeTitle":"Tidsovertrædelsesmindelse",
        "limitTimeTips":"Din spisningstid har overskredet den fastsatte tid. Kontakt venligst vores personale for service. Tak for din besøg!",
        "chargedOnceTips":"Kun den første portion af denne ret er betalt; efterfølgende tilføjelser er gratis.",
        "foodMaxEachTimeOrder":"Ret {foodName} kan kun bestilles op til {num} portioner pr. ordre. Venligst juster mængden og indsend igen. Tak!",
        "orderingTip":"Dette bord er under bestilling, prøv venligst lidt igen!",
        "personNum": "Antal spisende",
        "maxiNum": "Max. pr. person (portioner)",
        "upperLimit": "Samlet maks. (portioner)",
        "selectedList": "Valgte liste",
        "clickToSelect": "Klik for at vælge ovenfor",
        "delete": "Slet",
         "units": "Antal portioner",
        "who": "Tilhører (valgfrit)",
        "nullRemark": "Hvem bestilte",
        "needMax1": "Antal portioner må ikke være mindre end 1",
        "upperMaxLimit": "Overskrider den samlede grænse! Du kan højst bestille (portioner): ",
        "oneLimit": "{user} kan højst bestille {maxPerPerson} portion(er), har allerede bestilt {userUsed} portion(er)"
    },
    result: {
        tips: "Bestillingen er gennemført. Scan QR-koden igen for at bestille",
        closePage: "Luk side",
        errorTips: "Adgangssiden mangler, skan venligst QR-koden igen for at bestille"
    }
}


// WEBPACK FOOTER //
// ./src/assets/i18n/dk.js